import RefereeTitle from '@/orm/models/RefereeTitle'
import RefereesRepo from '@/orm/repositories/RefereesRepo'
import { Model, useRepo } from 'pinia-orm'
import { Attr, Str, HasManyBy } from 'pinia-orm/decorators'

export default class Referee extends Model {
    static entity = 'referees'

    @Str('', { notNullable: true })
    declare id: string
    @Str('', { notNullable: true })
    declare firstName: string
    @Str('', { notNullable: true })
    declare lastName: string
    @Str(null)
    declare sex: string
    @Str('', { notNullable: true })
    declare email: string
    @Str('', { notNullable: true })
    declare phone: string
    @Str(null)
    declare regId: string
    @Attr([])
    declare refTitleIds: number[]
    @HasManyBy(() => RefereeTitle, 'refTitleIds')
    declare titles: RefereeTitle[]

    get fullName(): string {
        return (this.firstName + ' ' + this.lastName).trim()
    }

    get reverseFullName(): string {
        return (this.lastName + ' ' + this.firstName).trim()
    }

    get fullNameWithIdentification(): string {
        return 'R' + this.id + ' ' + this.fullName + ' (' + this.identification + ')'
    }

    get reverseFullNameWithIdentification(): string {
        return 'R' + this.id + ' ' + this.reverseFullName + ' (' + this.identification + ')'
    }

    get reverseFullNameWithId(): string {
        return 'R' + this.id + ' ' + this.reverseFullName
    }

    get identification(): string {
        const me = this.titles !== undefined ? this : useRepo(RefereesRepo).with('titles').find(this.id)

        if (me !== null && me.titles !== undefined)
            return me.titles
                .sort((
                    a,
                    b,
                ) => (a.weight === b.weight ? a.visibleShortcut.localeCompare(b.visibleShortcut) : b.weight - a.weight))
                .map(title => (title.visibleShortcut))
                .join(', ')
        else
            return ''
    }

    static piniaOptions = {
        persist: true,
    }
}
